import React from "react";
import ReactDOM from "react-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import "semantic-ui-css/semantic.min.css";
import { useEffect, useState } from "react";
import "../Css/Home.css";
import "../Css/Reset.css";
import "../Css/Animations.css";
import {
  CardHeader,
  Container,
  Grid,
  Segment,
  Button,
} from "semantic-ui-react";
import renderOrbitBall from "../Components/OrbitBallEffect";

import portfolioIcon from "../images/portfolioIcon.png";

import HomeItemButton from "../Components/HomeItemButton";
import PortfolioSubBody from "../Components/PortfolioSubBody";
import PopupMenu from "../Components/PopupMenu";
import BlogSubBody from "../Components/BlogSubBody";
import { Localization, currentLang, Localizator } from "../utils/lang";
import StarBackground from "../Components/StarBackground";
import HireMeTab from "../Components/HireMeTab";
function Home() {
  const portfolioBody = () => {
    return <PortfolioSubBody></PortfolioSubBody>;
  };
  const blogBody = () => {
    return <BlogSubBody></BlogSubBody>;
  };
  const hiremeBody = () => {
    return <HireMeTab />;
  };

  //const [subBody, setSubBody] = useState(portfolioBody());
  const [subBody, setSubBody] = useState(portfolioBody);
  window.onbeforeunload = null;

  useEffect(() => {
    Aos.init();
    Aos.refresh();
  }, []);

  return (
    <>
      <StarBackground />

      <div className="root">
        {/* 背景線條 */}
        <div>
          {renderOrbitBall()}
          <canvas id="canvas" className="lineCanvas"></canvas>
        </div>
        {/*<PopupMenu />*/}
        {/* 主要選單 */}
        <div className="centerContainer" id="centerContainer">
          <Grid data-aos="zoom-in-up">
            <Grid.Column className="gridSubContaier">
              {/* 大頭貼 */}
              <img
                src="https://avatars.githubusercontent.com/u/45337164?s=400&u=189572e08cf2a7d3547556b33eabf28e5f3596ed&v=4"
                className="ui circular image avatorImage"
              />

              <h4 className="home__nameText ui horizontal divider header">
                {/*<i class="tag icon"></i>*/} Lontoone
              </h4>

              {/* 社群 按鈕群 */}
              <Grid.Row id="community-iconGroup">
                {/* 巴哈 */}
                <button
                  class=""
                  onClick={() => {
                    const url =
                      "https://home.gamer.com.tw/homeindex.php?owner=news2000tw";
                    window.open(url, "_blank");
                  }}
                >
                  <img
                    className="smallIcon"
                    src="https://cdn6.aptoide.com/imgs/e/f/a/efae200e586d616b816b01affb3e63d1_icon.png"
                  ></img>
                </button>

                {/* Github */}
                <button
                  class=""
                  onClick={() => {
                    const url = "https://github.com/Lontoone";
                    window.open(url, "_blank");
                  }}
                >
                  <img
                    className="smallIcon"
                    src="https://i.imgur.com/cpN5Xlp.png"
                  ></img>
                </button>

                {/* IG */}
                <button
                  class=""
                  onClick={() => {
                    const url = "https://www.instagram.com/lontoone/";
                    window.open(url, "_blank");
                  }}
                >
                  <img
                    className="smallIcon"
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png"
                  ></img>
                </button>
              </Grid.Row>

              {/* 主要 按鈕群*/}
              <Grid.Row className="mainButtonGroup">
                {/* 作品集- 按鈕 */}
                <HomeItemButton
                  icon={
                    "https://icon-library.com/images/about-me-icon-png/about-me-icon-png-6.jpg"
                  }
                  delay={0}
                  subText={Localizator("about_me")}
                  hiddenTitle={Localizator("about_me")}
                  onClick={() => {
                    setSubBody(portfolioBody);
                    let subBody = document.getElementById("subBody");
                    subBody &&
                      subBody.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                      });
                  }}
                ></HomeItemButton>

                {/* 部落格 */}
                <HomeItemButton
                  icon={portfolioIcon}
                  subText={Localizator("blog")}
                  hiddenTitle={Localizator("blog")}
                  delay={1}
                  onClick={() => {
                    setSubBody(blogBody);
                    let subBody = document.getElementById("subBody");
                    subBody &&
                      subBody.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                      });
                  }}
                ></HomeItemButton>

                {/* 工作 */}
                <HomeItemButton
                  delay={2}
                  icon={"https://i.imgur.com/NBUGEqn.png"}
                  subText={Localizator("job_offer")}
                  hiddenTitle={Localizator("job_offer")}
                  onClick={() => {
                    setSubBody(hiremeBody);
                    let subBody = document.getElementById("subBody");
                    subBody &&
                      subBody.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                      });
                  }}
                ></HomeItemButton>

                {/* 其他 */}
                <HomeItemButton
                  icon={
                    "https://icon-library.com/images/others-icon/others-icon-16.jpg"
                  }
                  delay={3}
                  subText={Localizator("other")}
                  hiddenTitle={"Coming Soon"}
                ></HomeItemButton>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </div>

        {/* 延伸內容 */}
        <div className="subBodyContainer" id="subBody">
          {subBody}
        </div>
      </div>
    </>
  );
}

export default Home;
